(jQuery.cookie = function (e, t, i) {
    if (void 0 !== t) {
        (i = i || {}), null === t && ((t = ""), (i.expires = -1));
        var o,
            r = "";
        i.expires && ("number" == typeof i.expires || i.expires.toUTCString) && ("number" == typeof i.expires ? (o = new Date()).setTime(o.getTime() + 864e5 * i.expires) : (o = i.expires), (r = "; expires=" + o.toUTCString()));
        var n = i.path ? "; path=" + i.path : "",
            s = i.domain ? "; domain=" + i.domain : "",
            l = i.secure ? "; secure" : "";
        document.cookie = [e, "=", encodeURIComponent(t), r, n, s, l].join("");
    } else {
        var a = null;
        if (document.cookie && "" != document.cookie)
            for (var c = document.cookie.split(";"), d = 0; d < c.length; d++) {
                var u = jQuery.trim(c[d]);
                if (u.substring(0, e.length + 1) == e + "=") {
                    a = decodeURIComponent(u.substring(e.length + 1));
                    break;
                }
            }
        return a;
    }
}),
    (Shopify.Products = (function () {
        var e = { howManyToShow: 3, howManyToStoreInMemory: 10, wrapperId: "recently-viewed-products", templateId: "recently-viewed-product-template", layout: "slider", swipe: !0, media: "adapt", onComplete: null },
            t = [],
            i = null,
            o = null,
            r = 0,
            n = {
                configuration: { expires: 90, path: "/", domain: window.location.hostname },
                name: "shopify_recently_viewed",
                write: function (e) {
                    jQuery.cookie(this.name, e.join(" "), this.configuration);
                },
                read: function () {
                    var e = [],
                        t = jQuery.cookie(this.name);
                    return null !== t && (e = t.split(" ")), e;
                },
                destroy: function () {
                    jQuery.cookie(this.name, null, this.configuration);
                },
                remove: function (e) {
                    var t = this.read(),
                        i = jQuery.inArray(e, t);
                    -1 !== i && (t.splice(i, 1), this.write(t));
                },
            },
            s = function () {
                if ((i.find(".item").length <= 2 && $("#recently-viewed-products-list").addClass("center"), $("#recently-viewed-products-list-2").addClass("recently-viewed-loaded"), i.show(), e.onComplete))
                    try {
                        e.onComplete();
                    } catch (t) {}
            },
            l = function () {
                if (t.length && r < e.howManyToShow) {
                    var o = window.routes.root + "/products/" + t[0] + "?view=ajax_recently_viewed";
                    jQuery.ajax({
                        type: "get",
                        url: o,
                        cache: !1,
                        success: function (e) {
                            i.append(e), t.shift(), r++, l();
                        },
                        error: function () {
                            n.remove(t[0]), t.shift(), l();
                        },
                    });
                } else s();
            },
            a = function () {
                if (t.length) {
                    var o = window.routes.root + "/collections/all";
                    let r = t.join(encodeURIComponent(","));
                    $.ajax({
                        type: "get",
                        url: o,
                        cache: !1,
                        data: { view: "ajax_recently_viewed", constraint: `limit=${t.length}+layout=${e.layout}+imageRatio=${e.media}+swipe=${e.swipe}+sectionId=recently-viewed+list_handle=` + r },
                        beforeSend: function () {},
                        success: function (e) {
                            let t = $(".halo-recently-viewed-block .recentlyViewed-row");
                            t.empty(), i.append(e);
                        },
                        error: function (e, t) {
                            alert($.parseJSON(e.responseText).description);
                        },
                        complete: function () {
                            if ("slider" == e.layout) {
                                var t = $(".halo-recently-viewed-block").find(".products-carousel"),
                                    i = t.data("item-to-show"),
                                    o = t.data("item-dots"),
                                    r = t.data("item-dots-mb"),
                                    n = t.data("item-arrows"),
                                    s = t.data("item-arrows-mb");
                                t.length > 0 &&
                                    t.not(".slick-initialized") &&
                                    t.slick({
                                        mobileFirst: !0,
                                        adaptiveHeight: !0,
                                        vertical: !1,
                                        infinite: !0,
                                        slidesToShow: 1,
                                        autoplay: true,
                                        slidesToScroll: 1,
                                        arrows: s,
                                        dots: r,
                                        nextArrow: window.arrows.icon_next,
                                        prevArrow: window.arrows.icon_prev,
                                        rtl: window.rtl_slick,
                                        responsive: [
                                            {
                                                breakpoint: 1599,
                                                settings: {
                                                    arrows: n,
                                                    dots: o,
                                                    // get slidesToShow() {
                                                    //     if (null != i && "" !== i) return (this.slidesToShow = i);
                                                    //     return (this.slidesToShow = 1);
                                                    // },
                                                    // get slidesToScroll() {
                                                    //     if (null != i && "" !== i) return (this.slidesToScroll = i);
                                                    //     return (this.slidesToScroll = 1);
                                                    // },
                                                },
                                            },
                                            {
                                                breakpoint: 1024,
                                                settings: {
                                                    arrows: n,
                                                    dots: o,
                                                    get slidesToShow() {
                                                        if (null == i || "" === i) return (this.slidesToShow = 1);
                                                        if (5 == i) return (this.slidesToShow = i - 1);
                                                        return (this.slidesToShow = i);
                                                    },
                                                    // get slidesToScroll() {
                                                    //     if (null == i || "" === i) return (this.slidesToScroll = 1);
                                                    //     if (5 == i) return (this.slidesToScroll = i - 1);
                                                    //     return (this.slidesToScroll = i);
                                                    // },
                                                },
                                            },
                                            { breakpoint: 991, settings: { arrows: s, centerMode: !0, centerPadding: "15px", infinite: !0, dots: r, slidesToShow: 4, slidesToScroll: 1 } },
                                            { breakpoint: 767, settings: { arrows: s, dots: r, centerMode: !0, centerPadding: "15px", infinite: !0, slidesToShow: 3, slidesToScroll: 1 } },
                                            { breakpoint: 320, settings: { centerMode: !0, centerPadding: "15px", infinite: !0, arrows: s, dots: r, slidesToShow: 2, slidesToScroll: 1 } },
                                        ],
                                    });
                            }
                        },
                    });
                }
            };
        return {
            resizeImage: function (e, t) {
                if (null == t) return e;
                if ("master" == t) return e.replace(/http(s)?:/, "");
                var i = e.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?/i);
                if (null == i) return null;
                var o = e.split(i[0]),
                    r = i[0];
                return (o[0] + "_" + t + r).replace(/http(s)?:/, "");
            },
            showRecentlyViewed: function (r) {
                var r = r || {};
                jQuery.extend(e, r),
                    (t = n.read()),
                    (o = e.templateId),
                    (i = jQuery("#" + e.wrapperId)),
                    (e.howManyToShow = Math.min(t.length, e.howManyToShow)),
                    e.howManyToShow && i.length && ("recently-viewed-product-popup" == o ? l() : a());
            },
            getConfig: function () {
                return e;
            },
            clearList: function () {
                n.destroy();
            },
            recordRecentlyViewed: function (t) {
                var t = t || {};
                jQuery.extend(e, t);
                var i = n.read();
                if (-1 !== window.location.pathname.indexOf("/products/")) {
                    if (null == window.location.pathname.match(/\/products\/([a-z0-9\-]+)/)) var o = decodeURIComponent(window.location.pathname.split("/products/")[1]);
                    else var o = window.location.pathname.match(/\/products\/([a-z0-9\-]+)/)[1];
                    var r = jQuery.inArray(o, i);
                    -1 === r ? (i.unshift(o), (i = i.splice(0, e.howManyToStoreInMemory))) : (i.splice(r, 1), i.unshift(o)), n.write(i);
                }
            },
        };
    })());
